import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const TransfusionProtocolPage = lazy(
  () => import('@/pages/transfusion-protocol/ui/index'),
)

export const Route = createFileRoute(
  '/_protected/recipients/transfusions/$transfusionId',
)({
  component: () => (
    <Suspense fallback={<Loader />}>
      <TransfusionProtocolPage />
    </Suspense>
  ),
})
